export const preloadImage = (imageUri: string) => {
  const img = new Image();
  img.src = imageUri;
};
